import DisplayGeojson from './DisplayGeojson';

const DisplayRegions = DisplayGeojson;

export default DisplayRegions;
